import React from 'react'
import { getDisplayAvatar } from '../../utils/profileManager'
import { useAuth } from '../../contexts/AuthContext'

/**
 * Unified Avatar Component
 * Supports both user prop and auth context
 * Flexible sizing with named sizes or custom Tailwind classes
 */
const UserAvatar = ({
  user: userProp,
  size = 'md',
  textSize,
  className = '',
  showFallback = true
}) => {
  const { user: authUser } = useAuth()
  const user = userProp || authUser

  // Named size presets
  const sizePresets = {
    xs: { container: 'w-6 h-6', text: 'text-xs' },
    sm: { container: 'w-8 h-8', text: 'text-sm' },
    md: { container: 'w-10 h-10', text: 'text-base' },
    lg: { container: 'w-12 h-12', text: 'text-xl' },
    xl: { container: 'w-16 h-16', text: 'text-2xl' },
    '2xl': { container: 'w-20 h-20', text: 'text-3xl' },
    '3xl': { container: 'w-24 h-24', text: 'text-4xl' }
  }

  // Determine size classes
  const preset = sizePresets[size]
  const containerSize = preset ? preset.container : size
  const textSizeClass = textSize || (preset ? preset.text : 'text-sm')

  if (!user && !showFallback) {
    return null
  }

  const avatar = user ? getDisplayAvatar(user) : { type: 'icon', icon: 'M' }

  return (
    <div
      className={`${containerSize} bg-gradient-to-br from-purple-500 to-pink-500 rounded-full flex items-center justify-center text-white font-semibold flex-shrink-0 overflow-hidden ${className}`}
    >
      {avatar.type === 'picture' ? (
        <img
          src={avatar.src}
          alt={user?.username || user?.firstName || 'User'}
          className="w-full h-full rounded-full object-cover"
        />
      ) : (
        <span className={textSizeClass}>{avatar.icon}</span>
      )}
    </div>
  )
}

export default UserAvatar
